module.exports = __webpack_public_path__ + "1f24482545825cc2853f6f8285f8994a.svg";